import React, { useEffect, useState } from "react";

export const useDebounce = (value, delay = 500) => {
  const [debounceValue, setDebounceValue] = useState(value);

  useEffect(() => {
    const handleSearch = setTimeout(() => {
      setDebounceValue(value);
    }, delay);

    return () => {
      clearTimeout(handleSearch);
    };
  }, [delay, value]);
  return debounceValue;
};